module.exports = __webpack_public_path__ + "static/img/service-ai-risk.bb1871ec.png";